import * as React from 'react';
import { ReactComponent as CellPhoneIconSVG } from '../../assets/icons/mevo/ic_cell_phone.svg';
import IconPattern, { IconProps } from './_IconPattern';

const CellPhoneIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={CellPhoneIconSVG} variantPlaces={1} {...props} />;
};

export default CellPhoneIcon;
